<div *ngIf="usuarioDemo" mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fas fa-hand-holding-water" id="ico"></i>
		<h1 style="display:inline-block;">Micromedidores</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div *ngIf="usuarioDemo" class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="row" *ngIf="micromedidor">
			<div class="col col-sm-12 col-md-7 col-lg-7 contenido">
				<i style="margin-right: 3px;" class="fal fa-barcode-alt col-md-1"></i><b>Numero de Serie:</b>
				{{micromedidor.numeroSerie}}<br>
				<i style="margin-right: 3px;" class="fal fa-comment-alt-lines col-md-1"></i><b>Observación:</b>
				{{micromedidor.observacion}}<br>
				<i style="margin-right: 3px;" class="fal fa-tint col-md-1"></i><b>Contador:</b> {{micromedidor.contador}}
				l<br>
				<!--<i style="margin-right: 10px;" class="fal fa-hand-holding-water"></i><b>Pulso:</b>
				{{micromedidor.valorPulso
				| number: '1.4-4'}} m3<br>-->
				<i style="margin-right: 3px;" class="fal fa-toggle-on col-md-1"></i><b>Estatus:</b> {{micromedidor.estatus}}<br>
				<i style="margin-right: 3px;" class="fal fa-draw-polygon col-md-1"></i><b>Geocerca:</b>
				<!--{{geocercaAsignada}}--><br>
				<i style="margin-right: 3px;" class="fal fal fa-calendar-alt col-md-1"></i><b>Fecha y hora:</b>
				{{micromedidor.fechaHora | date: 'yyy-MM-dd HH:MM a'}}<br>
				<i style="margin-right: 3px;" class="fas fa-faucet col-md-1"></i>
			</div>
			<div class="col col-sm-12 col-md-5 col-lg-5 contenido">
				<img [src]="imagen" style="width: 100%;" loading="lazy">
			</div>
		</div>
		<div class="row">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<button class="btnPopup ubicar mt-3" mat-raised-button (click)="ubicarMedidor()"><i id="btnIco"
						class="fal fa-binoculars"></i>&nbsp;Ubicar</button>&nbsp;
				<button class="btnPopup historico mt-3" mat-raised-button (click)="verHistorico()"><i id="btnIco"
						class="fal fa-calendar-alt"></i>&nbsp;Histórico</button>&nbsp;
				<button class="btnPopup streetView mt-3" mat-raised-button (click)="verCalle()"><i id="btnIco"
						class="fal fa-street-view"></i>&nbsp;Street View</button>&nbsp;
			</div>
		</div>
	</div>
</div>

<div *ngIf="!usuarioDemo" mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fas fa-water" id="ico"></i>
		<h1 style="display:inline-block;">Garzas</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div *ngIf="!usuarioDemo" class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="row">
			<div class="col col-sm-12 col-md-7 col-lg-7 contenido">
				<i style="margin-right: 3px;" class="fal fa-barcode-alt col-md-1"></i><b>&nbsp;&nbsp;Numero de Serie:</b>
				BEPYNS
				<br>
				<i style="margin-right: 3px;" class="fal fa-comment-alt-lines col-md-1"></i><b>&nbsp;Descripción:</b>
				Este es un demo
				<br>
				<i style="margin-right: 3px;" class="fal fa-tint col-md-1"></i><b>&nbsp;Modelo:</b> 
				Garza<br>
				<!--<i style="margin-right: 10px;" class="fal fa-hand-holding-water"></i><b>Pulso:</b>
				{{micromedidor.valorPulso
				| number: '1.4-4'}} m3<br>-->
				<i style="margin-right: 3px;" class="fal fa-toggle-on col-md-1"></i><b>&nbsp;Estatus:</b>
				Activo<br>
				<!-- <i style="margin-right: 3px;" class="fal fa-draw-polygon col-md-1"></i><b>Geocerca:</b>
				<br> -->
				<i style="margin-right: 3px;" class="fal fal fa-calendar-alt col-md-1"></i><b>&nbsp;Fecha y hora:</b>
				01/04/2022 4:44
				<br>
				<i style="margin-right: 3px;" class="fas fa-faucet col-md-1"></i>
			</div>
			<div class="col col-sm-12 col-md-5 col-lg-5 contenido">
				<img [src]="imagenDemo" style="width: 100%;" loading="lazy">
			</div>
		</div>
		<div class="row">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<button class="btnPopup ubicar mt-3" mat-raised-button (click)="ubicarMedidorDemo()"><i id="btnIco"
						class="fal fa-binoculars"></i>&nbsp;Ubicar</button>&nbsp;
				<button class="btnPopup historico mt-3" mat-raised-button (click)="verHistoricoDemo()"><i id="btnIco"
						class="fal fa-calendar-alt"></i>&nbsp;Histórico</button>&nbsp;
				<button class="btnPopup streetView mt-3" mat-raised-button (click)="verCalle()"><i id="btnIco"
						class="fal fa-street-view"></i>&nbsp;Street View</button>&nbsp;
			</div>
		</div>
	</div>
</div>
